<template>
  <div class="container">
    <div class="con">
      <div class="title">{{ title }}</div>
      <div class="list">
        <div v-if="hasLogin" class="list-item">
          <span>您好，</span><span>[ {{ userInfo.nickname }} ]</span>
          <span class="c-pointer" @click="goto('/person/center')"
            >[ 个人中心 ]</span
          >
          <span class="button" @click="loginOut()">安全退出</span>
        </div>
        <div v-else class="list-item status">
          <span class="span2">您好，请</span
          ><span class="button loginBtn" @click="login()">登录</span>
          <span class="span1 c-pointer" @click="applyCount">申请账号</span>
        </div>

        <div
          v-for="(item, index) in list"
          :key="index"
          class="list-item"
          @click="handlechange(index)"
          :class="[{ active: activeIndex == index }]"
        >
          <span :class="item.click ? 'c-pointer' : ''">
            <img
              v-if="item.icon"
              :src="require('@/assets/images/icon_phone.png')"
              alt=""
            />
            {{ item.title }}</span
          >
        </div>
        <div class="phone">
          <span>
            <img
              :src="require('@/assets/images/icon_phone.png')"
              alt=""
            />客服电话: {{ phone }}</span
          >
        </div>
      </div>
    </div>
    <popup
      class="popup-info"
      width="315px"
      height="160px"
      @close="close"
      v-if="show"
    >
      <div class="title">确定退出登录吗？</div>
      <div class="btn">
        <span class="span2" @click="close">取消</span>
        <span class="span1" @click="confirm">确定</span>
      </div>
    </popup>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      title: "您好~欢迎使用金源药业",
      activeIndex: null,
      list: [
        /* {
          title: "我的订单",
          click: true
        }, */
        {
          title: "帮助中心",
          click: true
        }
      ],
      show: false
    };
  },
  computed: {
    ...mapState(["hasLogin", "userInfo"]),
    ...mapState("sessionData", ["baseInfo"]),
    phone() {
      return this.baseInfo.phone;
    }
  },
  methods: {
    ...mapMutations(["LOGINOUT"]),
    goto(path) {
      this.$router.push(path);
    },
    applyCount() {
      this.$router.push({ path: "/login", query: { type: 2 } });
    },
    login() {
      this.$router.push({ path: "/login" });
    },
    loginOut() {
      this.show = true;
    },
    handlechange(i) {
      this.activeIndex = i;
      if (i == 0) {
        this.$store.state.hasLogin
          ? this.$router.push("/person/myorder")
          : this.$router.push("/login");
      } else if (i == 1) {
        this.$router.push({ name: "helpcenter" });
      }
    },
    close() {
      this.show = false;
    },
    confirm() {
      this.LOGINOUT();
      var fullPath = this.$route.fullPath.split("/");
      if (
        fullPath.indexOf("person") > -1 ||
        fullPath.indexOf("cart") > -1 ||
        this.$route.name == "shoppinglist" ||
        this.$route.name == "replenishList"
      ) {
        this.$router.push("/");
      }
      this.show = false;
    }
  },
  watch: {
    $route: {
      handler(t, f) {
        if (t.name != "myorder" && t.name != "helpcenter") {
          this.activeIndex = null;
        }
      }
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.container {
  font-size: 12px;
  color: #999999;
  height: 32px;
  background: #ffffff;
  line-height: 32px;
  border-bottom: 1px solid #f5f5f5;
}
.title {
  float: left;
}
.list {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 32px;
  .list-item {
    border-right: 1px solid #e6ebeb;
    line-height: 10px;
    height: 12px;
    padding-right: 16px;
    margin-right: 16px;
    span {
      img {
        vertical-align: middle;
        padding-bottom: 2px;
      }
    }
  }
}
.button {
  color: #f43737;
  cursor: pointer;
}
.loginBtn {
  margin-right: 16px;
}
.status {
  display: flex;
}
.ml {
  margin-left: 10px;
}
.active {
  color: #f43737;
}
.span1 {
  border-left: 1px solid #e6ebeb;
  padding-left: 16px;
}
.phone {
  span {
    img {
      margin-right: 6px;
      vertical-align: middle;
      padding-bottom: 4px;
    }
  }
}
.popup-info {
  .title {
    font-weight: 600;
    font-size: 18px;
    color: #333333;
    margin: 38px 0;
    text-align: center;
  }
  .btn {
    text-align: center;
    border-top: 1px solid #f8f8f8;
    span {
      @include btn(150px, 50px, #ffffff, #666666, 16px, 0);
    }
    .span1 {
      border-left: 1px solid #f8f8f8;
      color: #fa4b4b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/plugins/head-component.vue